import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { globals } from '../../../app.globals';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserSessionService {
  private endPoint = '/ValidateUser/AuthorizeUser';
  private userInfo;
  private auth;
  private googleEmail = '';
  private googleToken = '';
  public __validateUser: any;

  constructor(
    private http: HttpClient,
    private router: Router,) { }

  setUserFromAuthResponse(authResponse) {
    this.userInfo = authResponse.User; //authResponse.user_info;
    this.auth = (authResponse.token_type + ' ' + authResponse.access_token); //authResponse.token;
  }

  getUserInfo() {
    return this.userInfo;
  }
  getApiBaseUrl() {
    return globals.INSIGHTS_ROOT;
  }
  getAuthToken() {
    return this.auth;
  }
  setGoogleUser(email, token) {
    this.googleEmail = email;
    this.googleToken = token;
  }

  getGoogleUser() {
    return {
      email: this.googleEmail,
      token: this.googleToken,
    };
  }

  // validateUserMenu(){    
  //   const headers = new HttpHeaders({Authorization:this.getAuthToken()});
  //   return this.http.post(environment.API_OPS_BASE_URL + this.endPoint, {Menu: this.router.url}, {headers})
  //   .pipe(map(response => response['Validate']));
  // }
  
  validateUserMenu() {    
    const headers = new HttpHeaders({ Authorization: this.getAuthToken() });
    return this.http.post<any>(environment.API_OPS_BASE_URL + this.endPoint, { Menu: this.router.url }, { headers }).pipe(
      map((response: any) => {
        //console.log(response)
        this.setAuthoriseUser(response['validate']);
        return response;
      }));
  }

  setAuthoriseUser(data){
    this.__validateUser = data;
  }

  getAuthoriseUser(){
    return this.__validateUser;
  }

}
